export default __webpack_public_path__ + "static/media/gs8-ha-crm.62ceebb5.png";